module.exports = __webpack_public_path__ + "img/Brush-and-Scoop-min.58bb8e16.png";